export interface LoginCredentials {
  email: string;
  password: string;
  remember: boolean;
}

export interface AuthSession {
  token: string;
  userId: string;
  userName: string;
  expiresAt: string;
}

const SESSION_KEY = 'erp-session';

export const authService = {
  // TODO: replace with API call -> POST /api/auth/login
  login: async (credentials: LoginCredentials): Promise<AuthSession> => {
    await new Promise((resolve) => setTimeout(resolve, 1400));

    if (!credentials.email.includes('@') || credentials.password.length < 6) {
      throw new Error('Invalid email or password');
    }

    const session: AuthSession = {
      token: `mock-jwt-${Date.now()}`,
      userId: 'user-001',
      userName: credentials.email.split('@')[0],
      expiresAt: new Date(Date.now() + 8 * 3600 * 1000).toISOString(),
    };

    localStorage.setItem(SESSION_KEY, JSON.stringify(session));
    return session;
  },

  // TODO: replace with API call -> GET /api/auth/sso/url
  getSSOUrl: async (): Promise<string> => {
    await new Promise((resolve) => setTimeout(resolve, 200));
    return '/auth/sso/callback';
  },

  logout: async (): Promise<void> => {
    // TODO: replace with API call -> POST /api/auth/logout
    localStorage.removeItem(SESSION_KEY);
  },

  getSession: (): AuthSession | null => {
    try {
      const raw = localStorage.getItem(SESSION_KEY);
      if (!raw) return null;
      return JSON.parse(raw) as AuthSession;
    } catch {
      return null;
    }
  },

  hasValidSession: (): boolean => {
    const session = authService.getSession();
    if (!session?.token || !session.expiresAt) return false;
    return new Date(session.expiresAt).getTime() > Date.now();
  },
};
